import axios from 'axios'

export const branchHttp = axios.create({
  baseURL: import.meta.env.VITE_BRANCH_API_URL,
  timeout: 3600000,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
})
